import { EuiSpacer } from '@elastic/eui';
import DangerBox from 'components/Web_User_Interface/720p_Series/Alarm/SMTP_Server/DangerBox';
import SMTPTable from 'components/Web_User_Interface/720p_Series/Alarm/SMTP_Server/smtpTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  DangerBox,
  SMTPTable,
  BreadCrumbs,
  SEOHelmet,
  React
};